import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiCallService, NotificationService } from '@pm-ui/core-services';
import { AddTaskService } from 'libs/pm-services/src/lib/services';
import { ModalContainerComponent } from 'ngx-bootstrap/modal/modal-container.component';
import { SubSink } from 'SubSink';
//import { SubSink } from 'SubSink';

@Component({
  selector: 'pm-ui-lockand-delete-file-popup',
  templateUrl: './lockand-delete-file-popup.component.html',
  styleUrls: ['./lockand-delete-file-popup.component.scss']
})
export class LockandDeleteFilePopupComponent implements  OnInit {
  TaskSubTaskembdDocId:any;
  ElementList: any = ([] = []);
  isLoadingError = false;
  isLoading = false;
  operation:number=0;
  Title:any
  ConformationText:any
  submitted = false;
  loadingErrorMessage = '';
  @ViewChild('basicModal', { static: true }) basicModal: ModalContainerComponent | undefined;
  spinner:boolean=false;
  private readonly subSink = new SubSink();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  private apiCallService: ApiCallService,
  private taskService: AddTaskService,
 // private purchaseOrderService: PurchaseOrderService,
  private notificationService: NotificationService,
  public dialogRef: MatDialogRef<LockandDeleteFilePopupComponent>
  ) { 
    this.TaskSubTaskembdDocId= data.TaskSubTaskembdDocId;
    this.ElementList=data.Element
   this.Title= data.Title
   this.operation=data.Operation
    this.ConformationText =data.ConformationText
  }
  // ngOnDestroy(): void {
  //   throw new Error('Method not implemented.');
  // }

  ngOnInit(): void {
  }
  DeleteandlockEmbd(){
    if(this.ElementList!=null){
      if(this.operation<=1){
      var requesModel={
      // this.ElementList.IsLocked=true
      TaskSubtaskEmbeddedDocId:this.ElementList.taskSubTaskembdDocId,
      siteId:this.ElementList.siteId,
      FileSize:this.ElementList.fileSize,
      MimeType:this.ElementList.mimeType,
      SubtaskId:this.ElementList.subtaskId,
      FilePath:this.ElementList.filePath,
      TaskId:this.ElementList.taskId,
      FileName:this.ElementList.fileName,
      LoginUserId:this.ElementList.loginUserId,
      IsLocked:this.ElementList.isLocked,

      }
    this.subSink.sink = this.apiCallService.apiCall(
    this.taskService.UpdateFileNameForEmbd(requesModel),
    this.handleTaskLoadingProgress,
    (data:any) => {
      if(data!=null){
        //console.log(data)
        this.notificationService.success(data.message);
        this.dialogRef.close('Added');
      }
     
    //  this.apiCallService.sendSaveWOJobSheet();

    }
    );
  }
  else{
    var DeleteRequestModel={
      TaskSubtaskEmbeddedDocId:this.ElementList.taskSubTaskembdDocId,
      siteId:this.ElementList.siteId,
      TaskId:this.ElementList.taskId,
      SubtaskId:this.ElementList.subtaskId,
      IsLocked:this.ElementList.isLocked,
    }
    this.subSink.sink = this.apiCallService.apiCall(
      this.taskService.DeleteEmbdFile(DeleteRequestModel),
      this.handleTaskLoadingProgress,
      (data:any) => {
        if(data!=null){
          this.notificationService.success("File Is Deleted successfully");
          this.dialogRef.close('Added');
        }
       
      //  this.apiCallService.sendSaveWOJobSheet();
  
      }
      );
  }
  }
  }

  private handleTaskLoadingProgress = (
    isInProgress: boolean,
    isError: boolean,
    errorMessage: string
  ): void => {
    this.isLoading = isInProgress;
    this.isLoadingError = isError;
    this.loadingErrorMessage = errorMessage;
    if (isError && errorMessage) this.notificationService.error(errorMessage);
  };
  // private handleCommonInvoice = (isInProgress: boolean, isError: boolean, errorMessage: string): void => {
  //   this.isLoading = isInProgress;
  //   if (isError && errorMessage)
  //     this.notificationService.error(errorMessage);
  // }

  close() {   
    this.dialogRef.close(null);
  }

}
